import React, { useState } from 'react'
import logoImage from '../logo.png';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { Link } from 'react-router-dom';


export default function Header() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    return (
        <header className="fixed top-0 left-0 right-0 backdrop-blur-xl border-slate-200 z-50 shadow-sm bg-white">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="flex items-center justify-between h-20">
                    <Link to='/'>
                        <img src={logoImage} alt="YB Capital" className="h-14" /> </Link>

                    <nav className="hidden lg:flex items-center gap-10">
                        <Link to={'/'} className="text-white/70 hover:text-white/100 transition-all text-base font-medium">Home</Link>
                        <div className="relative group">
                            <button className="flex items-center gap-1 text-white/70 hover:text-white transition-all text-base font-medium">
                                About Us
                                <KeyboardArrowDownIcon className="w-4 h-4 group-hover:rotate-180 transition-transform duration-300" />
                            </button>

                            {/* Dropdown */}
                            <div className="absolute left-0 top-10 invisible opacity- group-hover:visible group-hover:opacity-100 transition-all duration-300 w-64 rounded-2xl  bg-gr backdrop-blur-xl border border-white/20 shadow-2xl p-3 z-50">

                                <Link
                                    to="/about"
                                    className="block px-4 py-3 rounded-xl text-white hover:bg-white/10 transition"
                                >
                                    Overview
                                </Link>

                                <Link
                                    to="/leadership"
                                    className="block px-4 py-3 rounded-xl text-white hover:bg-white/10 transition"
                                >
                                    Our Leadership
                                </Link>

                                <Link
                                    to="/location"
                                    className="block px-4 py-3 rounded-xl text-white hover:bg-white/10 transition"
                                >
                                    Locations
                                </Link>


                            </div>
                        </div>

                        <div className="relative group">
                            <button className="flex items-center gap-1 text-white/70 hover:text-white transition-all text-base font-medium">
                                Expertise
                                <KeyboardArrowDownIcon className="w-4 h-4 group-hover:rotate-180 transition-transform duration-300" />
                            </button>

                            {/* Dropdown */}
                            <div className="absolute left-0 top-10 invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-all duration-300 w-64 rounded-2xl bg-gr backdrop-blur-xl border border-white/20 shadow-2xl p-3 z-50">

                                <Link
                                    to="/expertises/debt-funding"
                                    className="block px-4 py-3 rounded-xl text-white hover:bg-white/10 transition"
                                >
                                    Debt Funding
                                </Link>

                                <Link
                                    to="/expertises/equity-raising"
                                    className="block px-4 py-3 rounded-xl text-white hover:bg-white/10 transition"
                                >
                                    Equity Raising
                                </Link>

                                <Link
                                    to="/expertises/hybrid-finance"
                                    className="block px-4 py-3 rounded-xl text-white hover:bg-white/10 transition"
                                >
                                    Hybrid Finance
                                </Link>

                                <Link
                                    to="/expertises/structured-finance"
                                    className="block px-4 py-3 rounded-xl text-white hover:bg-white/10 transition"
                                >
                                    Structured Finance
                                </Link>
                                <Link
                                    to="/expertises/international-funding"
                                    className="block px-4 py-3 rounded-xl text-white hover:bg-white/10 transition"
                                >
                                    International Funding
                                </Link>
                                <Link
                                    to="/expertises/international-funding"
                                    className="block px-4 py-3 rounded-xl text-white hover:bg-white/10 transition"
                                >
                                    Government Schemes
                                </Link>
                                <Link
                                    to="/expertises/international-funding"
                                    className="block px-4 py-3 rounded-xl text-white hover:bg-white/10 transition"
                                >
                                    New Age Funding
                                </Link>
                            </div>
                        </div>
                        <Link to={'/'} className="text-white/70 hover:text-white/100 transition-all text-base font-medium">Industries</Link>

                        <div className="relative group">
                            <button className="flex items-center gap-1 text-white/70 hover:text-white transition-all text-base font-medium">
                                Resource
                                <KeyboardArrowDownIcon className="w-4 h-4 group-hover:rotate-180 transition-transform duration-300" />
                            </button>

                            {/* Dropdown */}
                            <div className="absolute left-0 top-10 invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-all duration-300 w-64 rounded-2xl bg-gr backdrop-blur-xl border border-white/20 shadow-2xl p-3 z-50">

                                <Link
                                    to="/services/personal-loan"
                                    className="block px-4 py-3 rounded-xl text-white hover:bg-white/10 transition"
                                >
                                    Blogs
                                </Link>

                                <Link
                                    to="/services/business-loan"
                                    className="block px-4 py-3 rounded-xl text-white hover:bg-white/10 transition"
                                >
                                    Media Centers
                                </Link>

                                <Link
                                    to="/services/home-loan"
                                    className="block px-4 py-3 rounded-xl text-white hover:bg-white/10 transition"
                                >
                                    Careers
                                </Link>


                            </div>
                        </div>
                        <Link to={'/contact-us'} className="text-white/70 hover:text-white/100 transition-all text-base font-medium">Contact Us</Link>


                        
                    </nav>

                    <div className="hidden lg:flex items-center gap-4">
                        <button className="text-white px-5 py-2.5 bg-dark-gold rounded-full hover:shadow-lg hover:scale-105 transition-all font-semibold">
                            Enquiry-Now
                            <ArrowOutwardIcon />
                        </button>
                    </div>

                    <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden">
                        {mobileMenuOpen ? <p>open</p> : <p>cloded</p>}
                        {/* mobileMenuOpen ? <CloseIcon className="w-6 h-6" /> : <MenuIcon className="w-6 h-6" /> */}
                    </button>
                </div>
            </div>

            {mobileMenuOpen && (
                <div className="lg:hidden bg-white border-t border-slate-200 px-6 py-4">
                    <nav className="flex flex-col gap-4">
                        <a href="#solutions" className="text-slate-700 hover:text-[#1e3a8a] py-2">Home</a>
                        <a href="#platform" className="text-slate-700 hover:text-[#1e3a8a] py-2">About Us</a>
                        <a href="#pricing" className="text-slate-700 hover:text-[#1e3a8a] py-2">Service</a>
                        <a href="#resources" className="text-slate-700 hover:text-[#1e3a8a] py-2">Contact Us</a>
                        <div className="flex flex-col gap-2 pt-4 border-t border-slate-200">
                            <button className="text-slate-700 px-5 py-2.5 text-left">Sign In</button>
                            <button className="bg-gradient-to-r from-[#1e3a8a] to-[#0ea5e9] text-white px-6 py-2.5 rounded-full">
                                Get Started
                            </button>
                        </div>
                    </nav>
                </div>
            )}
        </header>
    )
}
